import axios from 'axios';
import { Role } from 'main/store/common/state';
import { API_URL, createHeaders } from '.';

type Member = {
    email: string;
    role: Role;
}

export const getRole = async (token: string) => {
    const response = await axios.get<Member>(`${API_URL}/members/myself`, createHeaders(token))
    return response.data.role;
}
